// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Baloo+2:wght@800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  background: white; /* Recomandat pentru lizibilitate peste news.jpg */
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.navbar-logo{
  display: flex;
  margin: auto;
}

.navbar-logo .logo {
  width: 70px;
  height: auto;
  display: block;
  margin:auto;
}
/* TEXT STYLE (ca în imagine) */
.hero-title {
  font-size: 38px;
  font-weight: 900;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    2px 2px 0 black,
    -2px 2px 0 black,
    2px -2px 0 black,
    -2px -2px 0 black;
  margin:auto;
  line-height: 1;
}
.nav-links {
  display: flex;
  align-items: center;
  list-style: none;
  gap: 30px;
}

.nav-links li a {
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.3s;
}

.nav-links li a:hover {
  color: #ffcc00;
}

/* Butonul special "Am găsit un animăluț" */
.nav-btn-special {
  background: #ffcc00;
  padding: 10px 20px;
  border-radius: 50px;
  color: #000 !important;
  box-shadow: 4px 4px 0px #000;
  border: 2px solid #000;
  transition: all 0.2s !important;
}
/* MOBILE */
@media (max-width: 480px) {
  .nav-btn-special {
    font-size: 15.5px;
  width: 250px;
  background: #ffcc00;
  padding: 10px 20px;
  border-radius: 50px;
  color: #000 !important;
  box-shadow: 4px 4px 0px #000;
  border: 2px solid #000;
  transition: all 0.2s !important;
}
}

.nav-btn-special:hover {
  transform: translate(-2px, -2px);
  box-shadow: 6px 6px 0px #000;
}

.navbar-menu-icon {
  display: none; /* Ascuns pe desktop */
  font-size: 1.8rem;
  cursor: pointer;
  z-index: 1001;
}

/* MOBILE */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 0px;
  }
}

/* MEDIA QUERY PENTRU MOBILE */
@media (max-width: 968px) {
  .navbar {
    padding: 10px 20px;
  }

  .navbar-menu-icon {
    display: block; /* Apare pe mobile */
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: -100%; /* Ascuns în afara ecranului */
    height: 100vh;
    width: 80%;
    background: #fff;
    flex-direction: column;
    justify-content: center;
    transition: right 0.4s ease-in-out;
    box-shadow: -10px 0 30px rgba(0,0,0,0.1);
  }

  .nav-links.nav-active {
    right: 0; /* Glisează în ecran */
  }

  .nav-links li {
    margin: 20px 0;
  }

  .nav-links li a {
    font-size: 1.2rem;
  }
}
.donatie-banner {
  background: #e6a4e6;
  height: 52px;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-top: 2px solid #000000;
  border-bottom: 2px solid #000000;
  cursor: pointer;
  transition: background 0.2s;
}
.donatie-banner:hover { background: #222; }

.donatie-text-alb {
  font-family: 'Baloo 2', cursive;
  font-weight: 900;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-shadow:
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;
}

.donatie-text-gold {
  font-family: 'Baloo 2', cursive;
  font-weight: 900;
  font-size: 18px;
  text-transform: uppercase;
  color: #000000;
}

.donatie-heart-icon {
  color: #f4b400;
  font-size: 16px;
  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.6)) drop-shadow(-1px -1px 0 #000) drop-shadow(1px 1px 0 #000);
  transition: all 0.3s ease;
}

.donatie-banner:hover .donatie-heart-icon {
  color: #f4b400;
  transform: scale(1.2);
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.9)) drop-shadow(-1px -1px 0 #000) drop-shadow(1px 1px 0 #000);
}

.donatie-banner-scroll {
  display: flex;
  white-space: nowrap;
  animation: scroll-left 25s linear infinite;
}

.donatie-banner-segment {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-right: 48px;
}

.donatie-mini-logo {
  height: 30px;
  opacity: 1;
}

.donatie-heart-icon {
  color: #f4b400;
  font-size: 16px;
  filter: drop-shadow(0 0 6px rgba(244,180,0,0.6));
  transition: all 0.3s ease; /* animatie smooth */
}

.donatie-banner:hover .donatie-heart-icon {
  color: #f4b400;
  transform: scale(1.2); /* micsoreaza/mareste usor */
  filter: drop-shadow(0 0 10px rgba(244,180,0,0.9)); /* glow mai puternic */
}

.donatie-text-alb {
  font-family: 'Baloo 2', cursive;
  font-weight: 900;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #ffffff;
}

.donatie-text-gold {
  font-family: 'Baloo 2', cursive;
  font-weight: 900;
  font-size: 18px;
  text-transform: uppercase;
  color: #000000;

}

.donatie-text-gold:hover {
  font-family: 'Baloo 2', cursive;
  font-weight: 900;
  font-size: 18px;
  text-transform: uppercase;
  color: #f4b400;
  text-shadow: 0 0 12px rgba(244,180,0,0.5);
}
.donatie-banner:hover .donatie-text-gold {
  color: #f4b400;
}

@keyframes scroll-left {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@media (max-width: 768px) {
  .donatie-text-alb { font-size: 13px; }
  .donatie-text-gold { font-size: 15px; }
  .donatie-banner { height: 44px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB,EAAE,kDAAkD;EACrE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;AACb;AACA,+BAA+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;AACjC;AACA,WAAW;AACX;EACE;IACE,iBAAiB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,QAAQ;EACV;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc,EAAE,oBAAoB;EACtC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,YAAY,EAAE,8BAA8B;IAC5C,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;IAClC,wCAAwC;EAC1C;;EAEA;IACE,QAAQ,EAAE,sBAAsB;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;AACA,wBAAwB,gBAAgB,EAAE;;AAE1C;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd;;;;oBAIkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yGAAyG;EACzG,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0GAA0G;AAC5G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gDAAgD;EAChD,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB,EAAE,4BAA4B;EACnD,iDAAiD,EAAE,sBAAsB;AAC3E;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;;AAEhB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB,eAAe,EAAE;EACrC,qBAAqB,eAAe,EAAE;EACtC,kBAAkB,YAAY,EAAE;AAClC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@800&display=swap');\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 40px;\n  background: white; /* Recomandat pentru lizibilitate peste news.jpg */\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n}\n\n.navbar-logo{\n  display: flex;\n  margin: auto;\n}\n\n.navbar-logo .logo {\n  width: 70px;\n  height: auto;\n  display: block;\n  margin:auto;\n}\n/* TEXT STYLE (ca în imagine) */\n.hero-title {\n  font-size: 38px;\n  font-weight: 900;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    2px 2px 0 black,\n    -2px 2px 0 black,\n    2px -2px 0 black,\n    -2px -2px 0 black;\n  margin:auto;\n  line-height: 1;\n}\n.nav-links {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  gap: 30px;\n}\n\n.nav-links li a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: color 0.3s;\n}\n\n.nav-links li a:hover {\n  color: #ffcc00;\n}\n\n/* Butonul special \"Am găsit un animăluț\" */\n.nav-btn-special {\n  background: #ffcc00;\n  padding: 10px 20px;\n  border-radius: 50px;\n  color: #000 !important;\n  box-shadow: 4px 4px 0px #000;\n  border: 2px solid #000;\n  transition: all 0.2s !important;\n}\n/* MOBILE */\n@media (max-width: 480px) {\n  .nav-btn-special {\n    font-size: 15.5px;\n  width: 250px;\n  background: #ffcc00;\n  padding: 10px 20px;\n  border-radius: 50px;\n  color: #000 !important;\n  box-shadow: 4px 4px 0px #000;\n  border: 2px solid #000;\n  transition: all 0.2s !important;\n}\n}\n\n.nav-btn-special:hover {\n  transform: translate(-2px, -2px);\n  box-shadow: 6px 6px 0px #000;\n}\n\n.navbar-menu-icon {\n  display: none; /* Ascuns pe desktop */\n  font-size: 1.8rem;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n/* MOBILE */\n@media (max-width: 768px) {\n  .nav-links {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 0px;\n  }\n}\n\n/* MEDIA QUERY PENTRU MOBILE */\n@media (max-width: 968px) {\n  .navbar {\n    padding: 10px 20px;\n  }\n\n  .navbar-menu-icon {\n    display: block; /* Apare pe mobile */\n  }\n\n  .nav-links {\n    position: fixed;\n    top: 0;\n    right: -100%; /* Ascuns în afara ecranului */\n    height: 100vh;\n    width: 80%;\n    background: #fff;\n    flex-direction: column;\n    justify-content: center;\n    transition: right 0.4s ease-in-out;\n    box-shadow: -10px 0 30px rgba(0,0,0,0.1);\n  }\n\n  .nav-links.nav-active {\n    right: 0; /* Glisează în ecran */\n  }\n\n  .nav-links li {\n    margin: 20px 0;\n  }\n\n  .nav-links li a {\n    font-size: 1.2rem;\n  }\n}\n.donatie-banner {\n  background: #e6a4e6;\n  height: 52px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  border-top: 2px solid #000000;\n  border-bottom: 2px solid #000000;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.donatie-banner:hover { background: #222; }\n\n.donatie-text-alb {\n  font-family: 'Baloo 2', cursive;\n  font-weight: 900;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n  text-shadow:\n    -1px -1px 0 #000,\n     1px -1px 0 #000,\n    -1px  1px 0 #000,\n     1px  1px 0 #000;\n}\n\n.donatie-text-gold {\n  font-family: 'Baloo 2', cursive;\n  font-weight: 900;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #000000;\n}\n\n.donatie-heart-icon {\n  color: #f4b400;\n  font-size: 16px;\n  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.6)) drop-shadow(-1px -1px 0 #000) drop-shadow(1px 1px 0 #000);\n  transition: all 0.3s ease;\n}\n\n.donatie-banner:hover .donatie-heart-icon {\n  color: #f4b400;\n  transform: scale(1.2);\n  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.9)) drop-shadow(-1px -1px 0 #000) drop-shadow(1px 1px 0 #000);\n}\n\n.donatie-banner-scroll {\n  display: flex;\n  white-space: nowrap;\n  animation: scroll-left 25s linear infinite;\n}\n\n.donatie-banner-segment {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-right: 48px;\n}\n\n.donatie-mini-logo {\n  height: 30px;\n  opacity: 1;\n}\n\n.donatie-heart-icon {\n  color: #f4b400;\n  font-size: 16px;\n  filter: drop-shadow(0 0 6px rgba(244,180,0,0.6));\n  transition: all 0.3s ease; /* animatie smooth */\n}\n\n.donatie-banner:hover .donatie-heart-icon {\n  color: #f4b400;\n  transform: scale(1.2); /* micsoreaza/mareste usor */\n  filter: drop-shadow(0 0 10px rgba(244,180,0,0.9)); /* glow mai puternic */\n}\n\n.donatie-text-alb {\n  font-family: 'Baloo 2', cursive;\n  font-weight: 900;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n}\n\n.donatie-text-gold {\n  font-family: 'Baloo 2', cursive;\n  font-weight: 900;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #000000;\n\n}\n\n.donatie-text-gold:hover {\n  font-family: 'Baloo 2', cursive;\n  font-weight: 900;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #f4b400;\n  text-shadow: 0 0 12px rgba(244,180,0,0.5);\n}\n.donatie-banner:hover .donatie-text-gold {\n  color: #f4b400;\n}\n\n@keyframes scroll-left {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n@media (max-width: 768px) {\n  .donatie-text-alb { font-size: 13px; }\n  .donatie-text-gold { font-size: 15px; }\n  .donatie-banner { height: 44px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
